(function () {
  'use strict';

  /**
   * @ngdoc directive
   * @name consult.directive:examcomments
   * @restrict EA
   * @element
   *
   * @description
   *
   * @example
     <example module="consult">
       <file name="index.html">
        <examcomments consult=""></examcomments>
       </file>
     </example>
   *
   */
  angular
    .module('consult')
    .directive('examcomments', examcomments);

  function examcomments() {
    return {
      restrict: 'EA',
      scope: {
        consult: '='
      },
      templateUrl: 'consult/examcomments-directive.tpl.html',
      replace: false,
      controllerAs: 'ecCtrl',
      bindToController: true,
      controller: function () {
        var vm = this;
        vm.name = 'examcomments';
        vm.popover = 'examcomments_popver.tpl.html';
        
      },
      link: function (scope, element, attrs) {
        /* jshint unused:false */
        /* eslint "no-unused-vars": [2, {"args": "none"}] */
      }
    };
  }
}());
